module.exports = __webpack_public_path__ + "img/pleisure_bodyimage02-3.d84819d2.jpg";